export const commonIcons = {
    iosSettings: 'ios-settings.svg',
    androidSettings: 'android-settings.svg',
    safari: 'safari.svg',
    chrome: 'chrome.svg',
    chromeSettings: 'chrome-settings.svg',
};

export const browserInstructions = {
    'Safari.Ios': [
        { key: 1, icon: commonIcons.iosSettings },
        { key: 2 },
        { key: 3, icon: commonIcons.safari },
        { key: 4 },
        { key: 5 },
        { key: 6 },
    ],
    'Safari.Desktop': Array.from({ length: 5 }, (_, i) => ({ key: i + 1 })),
    'Chrome.Ios': [
        { key: 1, icon: commonIcons.iosSettings },
        { key: 2 },
        { key: 3, icon: commonIcons.chrome },
        { key: 4 },
        { key: 5 },
        { key: 6 },
    ],
    'Chrome.Android': [
        { key: 1, icon: commonIcons.androidSettings },
        { key: 2 },
        { key: 3, icon: commonIcons.chrome },
        { key: 4 },
        { key: 5 },
        { key: 6 },
    ],
    'Chrome.Desktop': [
        { key: 1, icon: commonIcons.chromeSettings },
        { key: 2 },
        { key: 3 },
        { key: 4 },
    ],
    'Firefox.Ios': [
        { key: 1, icon: commonIcons.iosSettings },
        { key: 2 },
        { key: 3 },
        { key: 4 },
        { key: 5 },
        { key: 6 },
    ],
    'Firefox.Android': [
        { key: 1, icon: commonIcons.androidSettings },
        { key: 2 },
        { key: 3 },
        { key: 4 },
        { key: 5 },
        { key: 6 },
    ],
    'Firefox.Desktop': Array.from({ length: 6 }, (_, i) => ({ key: i + 1 })),
    'Edge.Desktop': Array.from({ length: 5 }, (_, i) => ({ key: i + 1 })),
};